var CatalogErrorMsgCms = /** @class */ (function () {
    function CatalogErrorMsgCms() {
    }
    CatalogErrorMsgCms.content = {
        CTLG_E400009: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Existing DirecTVNow Account',
        },
        CTLG_E400006: {
            message: 'Verify your address',
            shortMessage: 'Not able to retrieve CPC Response',
        },
        CTLG_E400004: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        CTLG_E500005: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        CTLG_E500007: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        CTLG_E500008: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        CTLG_E500010: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        CTLG_E500012: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        CTLG_E500013: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        CTLG_E500014: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        CTLG_E500015: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        CTLG_E500016: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        CTLG_E500017: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        CTLG_E500018: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        CTLG_E500019: {
            action: 'https://www.directvnow.com/',
            message: 'Redirect to url',
            shortMessage: 'Not a consumer account to retrieve offers',
        },
        errorDefaultMsg: {
            message: 'Please call us at 844.855.1539, so we can help with your order',
            shortMessage: 'Not a consumer account to retrieve offers',
            title: 'Uh-oh! Something went wrong',
        },
    };
    return CatalogErrorMsgCms;
}());
export { CatalogErrorMsgCms };
//# sourceMappingURL=CatalogErrorMsg.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/MainView/CatalogErrorMsg.cms.js
// module id = 1475
// module chunks = 8